export const SET_RECEITAS_PROPRIAS = 'SET_RECEITAS_PROPRIAS'
export const SET_DETALHAMENTO_DESPESAS = 'SET_DETALHAMENTO_DESPESAS'
export const SET_GRUPO_DESPESAS = 'SET_GRUPO_DESPESAS'
export const SET_FUNCAO_SUBFUNCAO = 'SET_FUNCAO_SUBFUNCAO'
export const SET_ADIANTAMENTOS = 'SET_ADIANTAMENTOS'
export const SET_DESPESAS_DETALHADAS = 'SET_DESPESAS_DETALHADAS'
export const SET_ANO_BASE = 'SET_ANO_BASE'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'


// WEBPACK FOOTER //
// ./src/store/modules/receitas_despesas/types.js